module.exports = __webpack_public_path__ + "static/media/the-telegraph-black.25b138da.png";